import { GridInt } from "interfaces";
import styles from "./Grid.module.scss";

const Grid = ({ className, children, ...rest }: GridInt) => {
  return (
    <div className={styles.grid + " " + styles[className]} {...rest}>
      {children}
    </div>
  );
};

export default Grid;
